/**
 * @generated SignedSource<<181d1b73e633ae8e771b37f0750ec8ae>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useSwitchToLivePageSubTypeFragment$data = {
  readonly subType: string | null | undefined;
  readonly " $fragmentType": "useSwitchToLivePageSubTypeFragment";
};
export type useSwitchToLivePageSubTypeFragment$key = {
  readonly " $data"?: useSwitchToLivePageSubTypeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSwitchToLivePageSubTypeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useSwitchToLivePageSubTypeFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "subType"
    }
  ],
  "type": "Content"
};

(node as any).hash = "83901263f96d64a150282b24a00afaf6";

export default node;
